import CertsModalCommentBox from './CertsModalCommentBox';

export default CertsModalCommentBox;
